<div class="box">
  <div class="background-image"></div>
  <div class="text-box">
    <div class="up-text">KUNSTMALER</div>
    <div class="main-text">Vittorio Del Basso</div>
  </div>
</div>


